import { createUseStyles } from 'react-jss'

export const useStyles = createUseStyles({
  dateRange: {
    // reset '.section .field' margin-top
    marginTop: [0, '!important']
  }
})

export default useStyles
